import React from "react";

import {
  Brand,
  Content,
  ContentVariants
} from "@patternfly/react-core";

import { bip } from "../../../config/bip";

import "./SchoolFooterBip.css";

const SchoolFooterBip = () => {
  return (
    <div className="school-footer-bip">
      <Content component={ContentVariants.h4}>
        Biuletyn Informacji Publicznej
      </Content>

      <a
        href={bip.href}
        target={bip.external ? "_blank" : undefined}
        rel={bip.external ? "noopener noreferrer" : undefined}
        className="school-footer-bip-link"
      >
        <Brand
            src={bip.logo.src}
            style={{
                height: `${bip.logo.height}px`,
                // height: `38px`,
                transform: `translate(${bip.logo.offset.x}px, ${bip.logo.offset.y}px)`
            }}
        />
      </a>
    </div>
  );
};

export default SchoolFooterBip;